import React from 'react';
import SliderImage from "./SliderTextBubbles/SliderImage";
import RatingItem from "./RatingItem";
import FrontSliderBlurb from "./FrontSliderBlurb";
import {contentURL} from "src/utilities/utilityFunctions";

const panelArray=[
        <img src={contentURL() +  "/site/images/layerslider-gallery-tn/sunset-meadow.png"} className="ls-bg" alt="Slide background" key={0}/>,

        <SliderImage top={95} left={-225} rotate={100} offsetxin={0} delayin={0} parallaxlevel={0} src={contentURL() +  "/site/images/layerslider-gallery/fridge-girl.png"} key={1}/>,
        <SliderImage top={3} left={386} rotate={100} offsetxin={-1300} offsetyin={0} offsetxout={1300} offsetyout={0} delayin={900} parallaxlevel={0} src={contentURL() +  "/site/images/layerslider-gallery/fridge.png"} key={2}/>,

        <SliderImage top={53} left={642} rotate={100} offsetxin={-126} offsetyin={295} delayin={1310} parallaxlevel={1} src={contentURL() +  "/site/images/layerslider-gallery/kid-stract.png"} key={3}/>,
        <SliderImage top={80} left={469} rotate={100} offsetxin={-427} offsetyin={315} delayin={2410} parallaxlevel={1} src={contentURL() +  "/site/images/layerslider-gallery/kid-house-1.png"} key={4}/>,
        <SliderImage top={248} left={457} rotate={100} offsetxin={-394} offsetyin={-63} delayin={3510} parallaxlevel={1} src={contentURL() +  "/site/images/layerslider-gallery/kid-lisa.png"} key={5}/>,
        <SliderImage top={246} left={645} rotate={100} offsetxin={1000} offsetyin={1000} delayin={3510} parallaxlevel={1} src={contentURL() +  "/site/images/layerslider-gallery/kid-house-2.png"} key={6}/>,
    <div className="ls-l"
         style={{top:"105px",left:"1350px"}}
         data-ls="offsetxin:500;offsetyin:0;delayin:3500;easingin:easeOutQuart;offsetxout:500;offsetyout:0;parallaxlevel:1;"
         key="blurb"
    >
        <FrontSliderBlurb delay="0" show="true"
                          blurb={"Brilliance should be saved! Save your pictures to the fridge for safe keeping."}/>
    </div>,

    <RatingItem yeatitle={"...I LOVE this!!"}
                    mehtitle={"...I could go for it. Maybe."}
                    naytitle={"...I don't see the point."} bgcolor={"#EEEEEE"}
                    top={450} left={1050}
                    audience={"adult"}
                    feature={"svToFridge"} label={"As an adult..."} key="sliderImage16"/>,
        <RatingItem yeatitle={"LOVE this!!"}
                    mehtitle={"take It Or Leave It"}
                    naytitle={"not like this."} bgcolor={"#EEEEEE"}
                    top={459} left={1050} audience={"child"}
                    feature={"svToFridge"}
                    label={"My child will..."}
                    key="sliderImage17"/>


];

const SaveDrawingToFridgeSlide = () => {
    return (
        <div className="ls-slide" data-ls="slidedelay:7000; transition2d: all;" style={{width:"100%"}} id="saveDrawingToFridge">
                {panelArray}
        </div>
    )
};

export default SaveDrawingToFridgeSlide;
